/**
 * Create by ZhiXiaPing on 2018/10/24
 *
 */
// -----------刷新页面的vuex
const state = {
  isRefresh: false
}
const mutations = {
  refresh (state) {
    state.isRefresh = true
    setTimeout(() => {
      state.isRefresh = false
    }, 30)
  }
}
const getters = {
  isRefresh: (state) => {
    return state.isRefresh
  }
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/isRefresh.js